"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const type_graphql_1 = require("type-graphql");
const typeorm_1 = require("typeorm");
const OsmosysBaseEntity_1 = require("../OsmosysBaseEntity");
const User_1 = require("./User");
const Workspace_1 = require("./Workspace");
let Organization = class Organization extends OsmosysBaseEntity_1.OsmosysBaseEntity {
};
tslib_1.__decorate([
    type_graphql_1.Field(() => User_1.User),
    typeorm_1.ManyToOne(() => User_1.User, {
        cascade: true,
        nullable: true,
        onDelete: 'SET NULL',
    }),
    tslib_1.__metadata("design:type", Object)
], Organization.prototype, "creatingUser", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column(),
    tslib_1.__metadata("design:type", String)
], Organization.prototype, "name", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [Workspace_1.Workspace], { nullable: true }),
    typeorm_1.OneToMany(() => Workspace_1.Workspace, ws => ws.organization),
    tslib_1.__metadata("design:type", Object)
], Organization.prototype, "workspaces", void 0);
Organization = tslib_1.__decorate([
    type_graphql_1.ObjectType(),
    typeorm_1.Entity()
], Organization);
exports.Organization = Organization;
class OrganizationEntity extends Organization {
    toString() {
        return this.name || `Organization #${this.id}`;
    }
    toEndpoint() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return `/admin/organizations/${this.id}`;
        });
    }
}
exports.OrganizationEntity = OrganizationEntity;
//# sourceMappingURL=Organization.js.map